import React from 'react';
import { Bar } from './SkeletonBar';

// Mirrors OrdersPage: hero card with progress + 4 steps, then today's order rows.
const OrdersScreenSkeleton = () => (
  <div className="min-h-screen bg-canvas pt-9 pb-28">
    <div className="max-w-md mx-auto px-4">
      <div className="rounded-xl bg-white border border-black/[0.05] p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <Bar className="h-4 w-3/5" />
            <Bar className="mt-2.5 h-3 w-full" />
            <Bar className="mt-1.5 h-3 w-2/3" />
          </div>
          <Bar className="w-16 h-16 shrink-0 rounded-xl" />
        </div>
        <Bar className="mt-4 h-1 w-full rounded-[2px]" />
        <div className="mt-2.5 flex items-center justify-between">
          <Bar className="h-3 w-8" />
          <Bar className="h-3 w-8" />
          <Bar className="h-3 w-8" />
          <Bar className="h-3 w-8" />
        </div>
      </div>

      <div className="mt-6 rounded-xl bg-white border border-black/[0.05] p-4">
        <Bar className="h-5 w-28" />
        <div className="mt-4 divide-y divide-black/[0.05]">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 py-3">
              <Bar className="w-11 h-11 shrink-0 rounded-xl" />
              <div className="flex-1">
                <Bar className="h-3.5 w-3/4" />
                <Bar className="mt-2 h-3 w-1/2" />
              </div>
              <Bar className="h-4 w-12 shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default OrdersScreenSkeleton;
